import { render, staticRenderFns } from "./Editc.vue?vue&type=template&id=23fea834&"
import script from "./Editc.vue?vue&type=script&lang=js&"
export * from "./Editc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports